import { render, staticRenderFns } from "./vsTrExpand.vue?vue&type=template&id=3e39d244"
import script from "./vsTrExpand.vue?vue&type=script&lang=js"
export * from "./vsTrExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports